/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SpoilerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgElEQVR4nN1Vy0oDUQydgroR/QK7FlE/QStCoWDzmMU00bruSkSroH6B9VMqBf/Bxyf4WHXlY6Oi3bZQuaWt105HZzrjQgMHLslNThJybxzn34jneRPIcgIkj8jaHgXA8oCsFRPLR2AMowZGPyo+gjiZ4yBIn4ZV0E4STlgCYL1G1F0AnUfEKYM1t7CALGUgvYlD0MyT7GcymbGgwTA2ZDkE0lZUgiaiYs9GJGlkqQFrg1nmfL6obscnLAGwbNnBgfSlZyuVSuPDqgHSnVAEwHruOE7qUy8125FIlgI6lkLSy58JXF39khlrY6B9dcTCcja7OUm0sWjfJZKVJAja/bukb5EJkORioEVnwQ9KqnaLgPUq3BS5ut3XozeLLK/+7OXZdYszViLlSGMKLGSVnkbSU2R574CkagfP0zpHGtNuf1tAchA0lkaMDViPRnlodp9vgXTPTEwuV5w2MGejA9a72H8RJvXZdZdFUgT3v7pwgPQ4YGVqJU4l8N3K/LPyAUTmawLmsiDAAAAAAElFTkSuQmCC)
 */
export const SpoilerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.56 11.77c.2-.1.44.02.44.23a4 4 0 1 1-4-4c.21 0 .33.25.23.44A2.5 2.5 0 0 0 14.5 12c.38 0 .74-.08 1.06-.23Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm10 1c4.99 0 7.3 4.4 7.86 5.67.1.21.1.45 0 .66C19.3 13.6 17 18 12 18s-7.3-4.4-7.86-5.67a.8.8 0 0 1 0-.66C4.7 10.4 7 6 12 6Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
